import Reserve from '../pages/Reserve/Reserve'
import InformationForm from '../pages/InformationForm/InformationForm'
import Result from '../pages/Result/Result'
import Search from '../pages/ReserveHistory/Search'
import HistoryResult from '../pages/ReserveHistory/HistoryResult'
import VaccineChoice from '../pages/Reserve/VaccineChoice'
import Explanation from '../pages/Reserve/Explanation'

const reserveRoutes = [
    {
        path: "/explanation",
        name: "說明與確認",
        component: Explanation
    },
    {
        path: "/vaccine_choice",
        name: "選擇接種疫苗",
        component: VaccineChoice
    },
    {
        path: "/first_step",
        name: "選擇日期",
        component: Reserve
    },
    {
        path: "/second_step",
        name: "填寫基本資料",
        component: InformationForm
    },
    {
        path: "/result",
        name: "預約完成",
        component: Result
    },
    // {
    //     path:"/second_step",
    //     name:"選擇預約時間",
    //     component: Reserve
    // },
    // {
    //     path:"/third_step",
    //     name:"簡訊驗證",
    //     component: Reserve
    // },
    // {
    //     path:"/fourth_step",
    //     name:"填寫基本資料",
    //     component: Reserve
    // },
    // {
    //     path:"/fifth_step",
    //     name:"預約完成",
    //     component: Reserve
    // }
]

const reserveHistoryRoute = [
    {
        path: "/search",
        name: "查詢預約紀錄",
        component: Search
    },
    {
        path: "/historyResult",
        name: "查詢預約紀錄結果",
        component: HistoryResult
    },
]

export {
    reserveRoutes,
    reserveHistoryRoute
}